import { render, staticRenderFns } from "./Vtal.vue?vue&type=template&id=61806de2&scoped=true&lang=pug&"
import script from "./Vtal.vue?vue&type=script&lang=js&"
export * from "./Vtal.vue?vue&type=script&lang=js&"
import style0 from "./Vtal.vue?vue&type=style&index=0&id=61806de2&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61806de2",
  null
  
)

export default component.exports